module.exports = __webpack_public_path__ + "static/media/about.e356360c.jpg";